import moment from 'moment';

// @vue/component
export default {
    computed: {
        reportingDateRangeGroups() {
            return [
                { name: 'months', ranges: this.reportingMonthRanges },
                { name: 'quarters', ranges: this.reportingQuarterRanges },
                { name: 'years', ranges: this.reportingYearRanges },
            ];
        },

        reportingMonthRanges() {
            return [
                this.createReportingDateRange(
                    'current-month',
                    this.$t('financial.payment_summary.quick_selection_current_month'),
                    this.reportingToday.clone().startOf('month'),
                    this.reportingToday.clone().endOf('month').startOf('day')
                ),
                this.createReportingDateRange(
                    'previous-month',
                    this.$t('financial.payment_summary.quick_selection_previous_month'),
                    this.reportingToday.clone().subtract(1, 'month').startOf('month'),
                    this.reportingToday.clone().subtract(1, 'month').endOf('month').startOf('day')
                ),
            ];
        },

        reportingQuarterRanges() {
            const currentQuarter = this.reportingToday.clone().startOf('quarter');

            return [0, 1, 2, 3].map(offset => {
                const start = currentQuarter.clone().subtract(offset, 'quarter');
                const quarter = start.quarter();
                const year = start.year().toString().slice(-2);

                return this.createReportingDateRange(
                    `quarter-${start.format('YYYY-Q')}`,
                    this.$t('financial.payment_summary.quick_selection_quarter', { quarter, year }),
                    start,
                    start.clone().endOf('quarter').startOf('day')
                );
            });
        },

        reportingToday() {
            const mockDate = window.sessionStorage.getItem('MOCK_DATE');

            return moment(mockDate || undefined).startOf('day');
        },

        reportingYearRanges() {
            return [
                this.createReportingDateRange(
                    'current-year',
                    this.$t('financial.payment_summary.quick_selection_current_year'),
                    this.reportingToday.clone().startOf('year'),
                    this.reportingToday.clone().endOf('year').startOf('day')
                ),
                this.createReportingDateRange(
                    'previous-year',
                    this.$t('financial.payment_summary.quick_selection_previous_year'),
                    this.reportingToday.clone().subtract(1, 'year').startOf('year'),
                    this.reportingToday.clone().subtract(1, 'year').endOf('year').startOf('day')
                ),
            ];
        },
    },

    methods: {
        createReportingDateRange(key, label, start, end) {
            return {
                key,
                label,
                value: [start.toDate(), end.toDate()],
            };
        },

        findReportingDateRange(value) {
            if (!Array.isArray(value) || value.length !== 2 || !value[0] || !value[1]) {
                return null;
            }

            const selectedRange = value.map(date => moment(date).format('YYYY-MM-DD'));

            return this.reportingDateRangeGroups
                .reduce((ranges, group) => ranges.concat(group.ranges), [])
                .find(range => range.value.every((date, index) => (
                    moment(date).format('YYYY-MM-DD') === selectedRange[index]
                ))) || null;
        },
    },
};
